var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterConfirmCountry.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxListItem, LoadingModal } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { CountryBottomSheetModal, Footer, Form, Header, LogoActionBar, Main, RichText, ScrollContainer, SelectorInput } from 'Components/utility';
import { REGISTER, REGISTER_CLEAR } from 'Reducers/register/types';
import { setUrls } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
const mapStateToProps = ({
  config: {
    supportedCountries
  },
  env
}) => {
  return {
    supportedCountries,
    env
  };
};
const connector = connect(mapStateToProps);
const RegisterConfirmCountry = ({
  next,
  back,
  values,
  supportedCountries,
  env
}) => {
  const [isBottomSheetModalOpen, setIsBottomSheetModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const onSubmit = useCallback(() => {
    const {
      language
    } = store.getState().lang;
    const register = {
      ...values,
      language,
      countryResidenceChecked: false
    };
    const config = store.getState().config;
    setUrls(config, register.country);
    next(register);
  }, [next, values]);
  const onCancelBottomSheetModal = useCallback(() => {
    setIsBottomSheetModalOpen(false);
  }, []);
  const onCountryOfResidenceChecked = useCallback(() => {
    store.dispatch({
      type: REGISTER,
      register: {
        ...values,
        countryResidenceChecked: !values.countryResidenceChecked,
        currentStep: 0
      }
    });
  }, [values]);
  const onSelectCountry = useCallback(async selectedCountry => {
    try {
      setIsBottomSheetModalOpen(false);
      setLoading(true);
      const {
        app,
        pId,
        redirect_uri,
        cid
      } = env;
      await updateConfig(selectedCountry, app, pId, redirect_uri, cid);
      setLoading(false);
      store.dispatch({
        type: REGISTER,
        register: {
          ...values,
          currentStep: 0,
          country: selectedCountry,
          ...(selectedCountry !== 'FR' && {
            gender: '',
            birthCountry: '',
            birthZipCode: ''
          })
        }
      });
    } catch {
      showApiErrorModal();
      setLoading(false);
    }
  }, [env, showApiErrorModal, values]);
  const handleOnBack = useCallback(() => {
    store.dispatch({
      type: REGISTER_CLEAR
    });
    back();
  }, [back]);
  const selectorValue = useMemo(() => {
    return values.country ? i18n.t(`Global.microcopy.countries.${values.country.toUpperCase()}`) : '';
  }, [values.country]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 5
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "ConfirmCountry.action-go-back",
    titleTestID: "ConfirmCountry.actionTitle",
    title: i18n.t('ConfirmCountry.title'),
    onBack: handleOnBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "ConfirmCountry.title",
    subtitleTestID: "ConfirmCountry.subtitle",
    title: i18n.t('ConfirmCountry.title'),
    subtitle: i18n.t('ConfirmCountry.subtitle'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SelectorInput, {
    testID: "ConfirmCountry",
    label: i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    placeholder: i18n.t('ConfirmCountry.content.selectCountry.secondaryText'),
    "aria-label": i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    value: selectorValue,
    onClick: () => setIsBottomSheetModalOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(CheckboxListItem, {
    checked: values.countryResidenceChecked,
    onPress: onCountryOfResidenceChecked,
    testID: "ConfirmCountry.checkBox"
    // @ts-expect-error all good.
    ,
    title: /*#__PURE__*/React.createElement(RichText, {
      text: i18n.t('ConfirmCountry.content.selectCountry.bodyText'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 161,
        columnNumber: 15
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('Global.microcopy.common.next'),
    onButtonSubmit: onSubmit,
    buttonTestID: "ConfirmCountry.next-btn",
    isButtonDisabled: !values.countryResidenceChecked || !values.country,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(CountryBottomSheetModal, {
    isOpen: isBottomSheetModalOpen,
    onCancel: onCancelBottomSheetModal,
    onDone: onSelectCountry,
    selectedCountry: values.country,
    title: i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    countries: supportedCountries,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 7
    }
  }));
};
export default connector(RegisterConfirmCountry);